import { AttachmentIcon } from "@chakra-ui/icons";
import { Box, Text } from "@chakra-ui/react";
import CloseIconMini from "common/assets/svg/CloseIconMini";
import ZipIcon from "common/assets/svg/ZipIcon";
import { constant } from "common/constant";
import React, { useState, useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";

const TOOLBAR_ID = "custom-toolbar";

const MAX_ATTACHMENTS = 3;

const HTMLEditor = ({
  value,
  isReadonly = false,
  onChange,
  onBlurHandler,
  onFilesChange,
}) => {
  const [attachments, setAttachments] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const remainingSlots = MAX_ATTACHMENTS - attachments.length;

    if (remainingSlots <= 0) {
      toast.error(`You can only attach up to ${MAX_ATTACHMENTS} files.`);
      return;
    }

    const filesToAdd = files.slice(0, remainingSlots);
    const updated = [...attachments, ...filesToAdd];
    setAttachments(updated);
    onFilesChange?.(updated);

    e.target.value = null;
  };

  const removeAttachment = (indexToRemove) => {
    const updated = attachments.filter((_, index) => index !== indexToRemove);
    setAttachments(updated);
    onFilesChange?.(updated);
  };

  useEffect(() => {
    const attachBtn = document.querySelector("#attach-btn");
    if (attachBtn && fileInputRef.current) {
      attachBtn.onclick = () => {
        fileInputRef.current.click();
      };
    }
  }, [attachments]);

  const HTMLEditorModules = {
    toolbar: {
      container: `#${TOOLBAR_ID}`,
    },
    clipboard: {
      matchVisual: false,
    },
  };

  return (
    <div style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
      {!isReadonly && (
        <div id={TOOLBAR_ID}>
          <span className="ql-formats">
            <select className="ql-header" defaultValue="">
              <option value="1" />
              <option value="2" />
              <option value="3" />
              <option value="" />
            </select>
            <select className="ql-font" />
            <select className="ql-size" />
          </span>
          <span className="ql-formats">
            <button className="ql-bold" />
            <button className="ql-italic" />
            <button className="ql-underline" />
            <button className="ql-strike" />
            <button className="ql-blockquote" />
          </span>
          <span className="ql-formats">
            <select className="ql-color" />
            <select className="ql-background" />
            <select className="ql-align" />
          </span>
          <span className="ql-formats">
            <button className="ql-list" value="ordered" />
            <button className="ql-list" value="bullet" />
            <button className="ql-indent" value="-1" />
            <button className="ql-indent" value="+1" />
          </span>
          <span className="ql-formats">
            {/* <button className="ql-image" />
            <button className="ql-video" /> */}
            <button id="attach-btn">
              <AttachmentIcon />
            </button>
            <button className="ql-clean" />
          </span>
        </div>
      )}

      <ReactQuill
        className="quill-container"
        value={value}
        modules={!isReadonly ? HTMLEditorModules : { toolbar: false }}
        onChange={onChange}
        onBlur={onBlurHandler}
        theme="snow"
        readOnly={isReadonly}
      />

      <input
        type="file"
        multiple
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {!isReadonly && attachments.length > 0 && (
        <>
          <Text className="attactmentCount">
            {constant.attactments} ({attachments.length})
          </Text>
          <div style={{ marginTop: 10 }} className="attachmentsMain">
            {attachments.map((file, index) => (
              <div
                key={index}
                className="attachmentBox"
                style={{
                  display: "flex",
                  gap: "24px",
                  marginBottom: "4px",
                  alignItems: "center",
                }}
              >
                <Box display={"flex"} alignItems={"center"} gap={"12px"}>
                  <Box className="attachIcon">
                    <ZipIcon />
                  </Box>
                  <Box className="attachInfo">
                    <Text className="attachFileName">{file.name}</Text>
                    <Text className="attachFileSize">
                      ({Math.round(file.size / 1024)} KB)
                    </Text>
                  </Box>
                </Box>

                <button
                  type="button"
                  onClick={() => removeAttachment(index)}
                  title="Remove"
                  className="removeAttachmentBtn"
                >
                  <CloseIconMini />
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default HTMLEditor;
